<div class="modal-content">
  <div class="modal-header align-items-center">
    <div class="d-flex flex-column">
      <h2 class="modal-title mb-1">{{ editMode ? ('companyProfile.addDeal.editTitle' | translate) : ('companyProfile.addDeal.title' | translate) }}</h2>
      <p class="text-muted small mb-0">{{ 'common.requiredFields' | translate }}</p>
    </div>
    <i class="fa-solid fa-xmark fs-2 cursor-pointer" (click)="close()"></i>
  </div>

  <div class="modal-body">
    <div class="row">
      <h3>{{ 'companyProfile.addDeal.dealInfo' | translate }}</h3>
    </div>

    <div class="row spacing-15">
      <div class="col-12">
        <app-input-component
          [label]="('companyProfile.addDeal.dealTitle' | translate) + ' *'"
          [type]="'text'"
          [placeholder]="'companyProfile.addDeal.dealTitlePlaceholder' | translate"
          [(value)]="title"
          [invalid]="isTitleInvalid"
        />
      </div>
    </div>

    <div class="row spacing-15">
      <div class="col-12">
        <app-input-component
          [label]="'companyProfile.addDeal.description' | translate"
          [type]="'text'"
          [placeholder]="'companyProfile.addDeal.descriptionPlaceholder' | translate"
          [(value)]="description"
        />
      </div>
    </div>

    <div class="row spacing-15">
      <div class="col-md-6">
        <app-input-component
          [label]="('companyProfile.addDeal.startDate' | translate) + ' *'"
          [type]="'date'"
          [(value)]="start_date"
          [invalid]="isStartDateInvalid"
        />
      </div>
      <div class="col-md-6">
        <app-input-component
          [label]="('companyProfile.addDeal.endDate' | translate) + ' *'"
          [type]="'date'"
          [(value)]="end_date"
          [invalid]="isEndDateInvalid"
        />
      </div>
    </div>

    <div class="row spacing-15">
      <div class="col-md-6">
        <app-input-component
          [label]="('companyProfile.addDeal.discountCode' | translate) + ' *'"
          [type]="'text'"
          [placeholder]="'companyProfile.addDeal.discountCodePlaceholder' | translate"
          [(value)]="discount_code"
          [invalid]="isDiscountCodeInvalid"
        />
      </div>
      <div class="col-md-6">
        <app-input-component
          [label]="'companyProfile.addDeal.discountPercentage' | translate"
          [type]="'number'"
          [placeholder]="'companyProfile.addDeal.discountPercentagePlaceholder' | translate"
          [(value)]="discount_percentage"
        />
      </div>
    </div>

    <div class="row spacing-30">
      <div class="col-12">
        <h4>{{ 'companyProfile.addDeal.image' | translate }}</h4>
        <p class="text-muted small mb-2">{{ 'companyProfile.addDeal.imageHint' | translate }}</p>
        <app-fileorini
          [accept]="'image/*'"
          (filesChanged)="imageFile = $event[0]"
        />
      </div>
    </div>
  </div>

  <div class="modal-footer">
    <div class="row">
      <div class="col-12 d-flex justify-content-end gap-2">
        <app-button
          [variant]="'ghost'"
          [label]="'common.cancel' | translate"
          (clicked)="close()"
        />
        <app-button
          [variant]="'primary'"
          [label]="saving ? ('common.saving' | translate) : (editMode ? ('common.saveChanges' | translate) : ('companyProfile.addDeal.add' | translate))"
          [iconClass]="saving ? 'fa fa-spinner fa-spin' : (editMode ? 'fa fa-save' : 'fa fa-plus')"
          [disabled]="saving"
          (clicked)="onSave()"
        />
      </div>
    </div>
  </div>
</div>
